import { useEffect, useState } from "react";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import { MasterDataSelections } from "../../Pages/Form/EditFieldAttribute/EditFieldMasterData";
import axiosInstance, { handleApiError } from "../../services/axiosService";
import ColorConfig from "../BuilderComponents/ColorConfig";
import FieldFormatSelection from "../BuilderComponents/FieldFormateSelection";
import SingleJobPopup from "../BuilderComponents/JobConfigration/SingleJobPopup";
import { AddAndDeleteInlineIcon } from "../BuilderComponents/Preview/IconPreview";
import TableTreeModal from "../BuilderComponents/TableTreeModal";
import Input from "../FormComponents/Input";
import Label from "../FormComponents/Label";
import MultiRadio from "../FormComponents/MultiRadio";
import Textarea from "../FormComponents/Textarea";
import EditImageConfig from "./EditImageConfig";
import { TableStyleTypes } from "./EditTableviewSidebar";
import { CatalogEditContainer } from "./EditRecordviewTable";
import EditRecordviewOnScreenFilters from "../../Pages/ApplicationBlock/RecordsViewRenderer/Desktop/RecordsViewEdit/EditRecordviewOnScreenFilters";
import InfoTooltip from "../BuilderComponents/InfoTooltip";
import { getPositionedElementConfig } from "../../Pages/FlexibleLayout/utils";
import FieldSelectorFromPopup from "../BuilderComponents/FieldSelectorFromPopup";
import EditFile from "./EditFile";
import { getToolTipAttributes } from "../../utils/tooltip";

const EditField = ({ editElementData, setEditElementData, tableID }) => {
  const [errorLabel, setErrorlabel] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const openModal = () => {
    setIsModalOpen(true);
  };
  const handleChangeField = (field) => {
    setEditElementData({ ...editElementData, ...field });
    closeModal();
  };
  const handleEditElementData = (type, data) => {
    if (type === "cards_per_row") {
      if (!isNaN(data) && data > 6) {
        setErrorlabel("cards_per_row");
        return;
      }
    }
    setErrorlabel("");
    setEditElementData({ ...editElementData, [type]: data });
  };

  const handleTableTypeFunction = (value) => {
    setEditElementData({ ...editElementData, table_type: value });
  };

  const editFieldData = () => {
    switch (editElementData.field_type) {
      case "recordset":
      case "recordset-list":
      case "grid":
        return (
          <RecordsetFieldData
            editElementData={editElementData}
            handleEditElementData={handleEditElementData}
            errorLabel={errorLabel}
            handleTableTypeFunction={handleTableTypeFunction}
          />
        );
      case "lookup-sm":
        return <LookupSmFieldData editElementData={editElementData} handleEditElementData={handleEditElementData} />;
      default:
        return (
          <DefaultFieldData
            editElementData={editElementData}
            setEditElementData={setEditElementData}
            tableID={tableID}
          />
        );
    }
  };
  return (
    <>
      <div className="flex_column gap_2">
        <Label>Field Name</Label>
        <div onClick={openModal} className="builder_input cursor_pointer text_center">
          {editElementData.id ? editElementData.display : "Select Field"}
        </div>
      </div>
      {/* {editFieldData()} */}
      {editElementData?.field_type === "image" || editElementData?.field_type === "file" ? (
        <EditImageConfig editElementData={editElementData} setEditElementData={setEditElementData} fieldFlag={true} />
      ) : (
        editFieldData()
      )}
      <BuilderModal isOpen={isModalOpen} onClose={closeModal} modalName="Select Field">
        <TableTreeModal
          callbackFunction={handleChangeField}
          tableId={tableID}
          selectedFile={editElementData && editElementData?.preview_field && editElementData?.preview_field?.id}
        />
      </BuilderModal>
    </>
  );
};

const LookupSmFieldData = ({ editElementData, handleEditElementData }) => {
  return (
    <>
      <div className="d_flex">
        {!editElementData.icon && <Label>Add Icon</Label>}{" "}
        <AddAndDeleteInlineIcon
          icon={editElementData.icon}
          callbackFunction={(data) => handleEditElementData("icon", data)}
        />
      </div>
    </>
  );
};

const RecordsetFieldData = ({ editElementData, handleEditElementData, errorLabel, handleTableTypeFunction }) => {
  return (
    <>
      <Input
        type="number"
        label="Cards Per Row"
        min="1"
        max="10"
        name="cards_per_row"
        value={editElementData.cards_per_row}
        onChange={({ target }) => handleEditElementData(target.name, target.value)}
      />
      <div className="field_horizontal_container">
        <Input
          type="checkbox"
          name="table_format"
          checked={editElementData.table_format || false}
          onChange={({ target }) => handleEditElementData(target.name, target.checked)}
          label="Table Format"
          containerClassName="w_50"
        />

        <Input
          type="checkbox"
          name="show_serial_number"
          checked={editElementData.show_serial_number || false}
          onChange={({ target }) => handleEditElementData(target.name, target.checked)}
          label="Show serial number"
          containerClassName="w_50"
        />
      </div>

      {errorLabel === "cards_per_row" && <label className="builder_label label_error">Max 6 cards are allowed</label>}
      {editElementData?.table_format && (
        <TableStyleTypes type={editElementData.table_type || ""} onChange={handleTableTypeFunction} />
      )}
    </>
  );
};

const DefaultFieldData = ({ editElementData, setEditElementData }) => {
  const handleEditElementData = (type, value) => {
    setEditElementData({ ...editElementData, [type]: value });
  };
  return (
    <>
      <div className="flex_column gap_2">
        <Label>Placeholder</Label>
        <div className="d_flex">
          <AddAndDeleteInlineIcon
            icon={editElementData.icon}
            callbackFunction={(data) => setEditElementData({ ...editElementData, icon: data })}
          />
          <Input
            type="text"
            value={editElementData.placeholder || ""}
            inputClassName="border_left_none outline_none"
            onChange={(e) => setEditElementData({ ...editElementData, placeholder: e.target.value })}
          />
        </div>
      </div>

      <div className="field_horizontal_container">
        <div>
          <Input
            type="text"
            label="Prefix"
            value={editElementData.prefix_data || ""}
            onChange={(e) => setEditElementData({ ...editElementData, prefix_data: e.target.value })}
          />
        </div>
        <div>
          <Input
            type="text"
            label="Postfix"
            value={editElementData.postfix_data || ""}
            onChange={(e) => setEditElementData({ ...editElementData, postfix_data: e.target.value })}
          />
        </div>
      </div>
      <Textarea
        label="Transform data function"
        value={editElementData.transform_field_data}
        onChange={(e) => setEditElementData({ ...editElementData, transform_field_data: e.target.value })}
      />

      <TypeSpecificFields editElementData={editElementData} onChange={handleEditElementData} />

      {editElementData?.field_type === "selectboxes" && (
        <div className="flex_column gap_2 ">
          <Label>Styles</Label>
          <Input
            type="checkbox"
            label="Chips Format"
            name="show_chips"
            checked={editElementData?.show_chips}
            onChange={({ target }) => setEditElementData({ ...editElementData, [target.name]: target.checked })}
          />
        </div>
      )}
      {editElementData?.field_type === "json" && (
        <div className="flex_column gap_2">
          <Input
            type="checkbox"
            label="Raw JSON"
            name="raw_json"
            checked={editElementData.raw_json ?? false}
            onChange={({ target }) => setEditElementData({ ...editElementData, [target.name]: target.checked })}
          />
        </div>
      )}
      <Input
        type="checkbox"
        label="Separator"
        name="align_value_vertical"
        checked={editElementData.align_value_vertical}
        onChange={({ target }) => setEditElementData({ ...editElementData, [target.name]: target.checked })}
      />
      <Input
        type="checkbox"
        label="Show as Ellipsis"
        name="show_as_ellipsis"
        checked={editElementData?.show_as_ellipsis || false}
        onChange={({ target }) => setEditElementData({ ...editElementData, [target.name]: target.checked })}
      />
      <InlineColorMasterdataSelection
        colorConfigType={editElementData?.color_config_type}
        handleEditElementData={handleEditElementData}
        colorMasterData={editElementData?.color_master_data || ""}
        colorIf={editElementData?.colorif}
      />
    </>
  );
};

export const InlineColorMasterdataSelection = ({
  colorConfigType,
  handleEditElementData,
  colorMasterData,
  colorIf,
  colorIfField,
  tableId,
  tableType
}) => {
  return (
    <>
      <div className="flex_column gap_2 mb_1">
        <Label>Color config type</Label>
        <MultiRadio
          options={[
            {
              id: "",
              name: "None"
            },
            {
              id: "masterdata",
              name: "Master data"
            },
            {
              id: "inline",
              name: "Inline"
            }
          ]}
          selectedValue={colorConfigType}
          onChange={(e) => handleEditElementData("color_config_type", e.target.value)}
        />
      </div>

      {colorConfigType === "masterdata" && (
        <MasterDataSelections
          selectedMasterData={colorMasterData || ""}
          onChange={(data) => handleEditElementData("color_master_data", data)}
          selectedTypes={["color_config"]}
          label={
            <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              Select color master data
              <InfoTooltip documentKey="select_color_master_data" />
            </span>
          }
        />
      )}

      {colorConfigType === "inline" && (
        <div className="flex_column gap_3">
          {tableId && tableType && (
            <FieldSelectorFromPopup
              tableId={tableId}
              tableType={tableType}
              onSelect={(data) => handleEditElementData("colorif_field", data.id)}
              fieldId={colorIfField || ""}
            />
          )}
          <ColorConfig value={colorIf} onChange={(data) => handleEditElementData("colorif", data)} />
        </div>
      )}
    </>
  );
};

const TypeSpecificFields = ({ editElementData, onChange }) => {
  const getSelectiveFields = (type) => {
    switch (type) {
      case "number":
      case "int":
        return (
          <>
            <div className="flex_column gap_2 ">
              <Label>Styles</Label>
              <Input
                type="checkbox"
                label="Chips Format"
                name="show_chips"
                checked={editElementData?.show_chips}
                onChange={({ target }) => onChange(target.name, target.checked)}
              />
            </div>
            <FieldFormatSelection
              type="number"
              value={editElementData?.format || ""}
              onChange={(newValue) => onChange("format", newValue)}
            />
            <FieldFormatSelection
              type="currency"
              value={editElementData?.currency_code || ""}
              onChange={(newValue) => onChange("currency_code", newValue)}
              label="Currency Format"
            />
          </>
        );
      case "date":
      case "date-range":
        return (
          <>
            <div className="field_horizontal_container">
              <Input
                type="checkbox"
                label="Chips Format"
                name="show_chips"
                checked={editElementData?.show_chips}
                onChange={({ target }) => onChange(target.name, target.checked)}
                containerClassName="w_50"
              />
            </div>
            <FieldFormatSelection
              type="date"
              value={editElementData?.format || ""}
              onChange={(newValue) => onChange("format", newValue)}
            />
          </>
        );
      case "time":
        return (
          <FieldFormatSelection
            type="time"
            value={editElementData?.format || ""}
            onChange={(newValue) => onChange("format", newValue)}
          />
        );
      case "datetime":
        return (
          <FieldFormatSelection
            type="datetime"
            value={editElementData?.format || ""}
            onChange={(newValue) => onChange("format", newValue)}
          />
        );
      case "textfield":
      case "learning-text":
      case "email":
      case "varchar":
        return (
          <>
            <div className="flex_column gap_2 ">
              <Label>Styles</Label>
              <div className="field_horizontal_container">
                <Input
                  type="checkbox"
                  label="Chips Format"
                  name="show_chips"
                  checked={editElementData?.show_chips}
                  onChange={({ target }) => onChange(target.name, target.checked)}
                  containerClassName="w_50"
                />

                <Input
                  type="checkbox"
                  label="Avatar"
                  name="show_avatar"
                  checked={editElementData?.show_avatar}
                  onChange={({ target }) => onChange(target.name, target.checked)}
                  containerClassName="w_50"
                />
              </div>
            </div>
          </>
        );
      case "select":
      case "id-gen":
      case "multi-date":
        return (
          <>
            <div className="flex_column gap_2 ">
              <Label>Styles</Label>
              <Input
                type="checkbox"
                label="Chips Format"
                name="show_chips"
                checked={editElementData?.show_chips}
                onChange={({ target }) => onChange(target.name, target.checked)}
              />
            </div>
          </>
        );

      default:
        return null;
    }
  };

  return <>{getSelectiveFields(editElementData.field_type)}</>;
};

const TableFieldAction = ({ fieldConfig, onChange, tableID = "", tableType = "statemachine", device = "desktop" }) => {
  // const [jobName, setJobName] = useState("");
  // const [selectedType, setSelectedType] = useState("button"); // Default to "button"

  const [allJobs, setAllJobs] = useState([]);
  const fetchAllTemplatesAndJobs = async () => {
    try {
      const { data } = await axiosInstance.get(`/jobs/filter/?places=${"records_view_cell"}`);
      setAllJobs(data);
    } catch (error) {
      handleApiError(error);
    }
  };
  useEffect(() => {
    fetchAllTemplatesAndJobs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!fieldConfig) return null;

  const {
    parent_type: parentType = "",
    field_type: fieldType = "",
    table_id: currTID = "",
    parent_table_id: selectedFieldTableID = "",
    field_action: fieldAction = null
  } = fieldConfig;

  const fieldLookup = selectedFieldTableID.split(".");
  const fileTableID = fieldLookup[fieldLookup.length - 1];

  let newTableID = tableID;

  const showActionJob = ["lookup", "app-user"].includes(parentType) || ["lookup-sm"].includes(fieldType);

  if (showActionJob && parentType === "lookup") {
    newTableID = fileTableID;
  }
  if (showActionJob && fieldType === "lookup-sm") {
    newTableID = currTID;
  }

  if (!newTableID) return null;

  return (
    <SingleJobPopup
      config={fieldAction}
      allJobs={allJobs}
      smId={newTableID}
      device={device}
      onChange={onChange}
      label={"On Click Job"}
      type={tableType}
    />
  );
};

const EditFieldForPositionedScreen = ({ editElementData, setEditElementData, tableID, targetFolderPath }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => {
    setIsModalOpen(false);
  };
  const openModal = () => {
    setIsModalOpen(true);
  };
  const handleChangeField = (field) => {
    setEditElementData({
      ...editElementData,
      ...field,
      catalog: {
        layout: [getPositionedElementConfig("section")],
        cards_per_row: 1
      }
    });
    closeModal();
  };
  const handleEditElementData = (type, data) => {
    setEditElementData({ ...editElementData, [type]: data });
  };

  const handleTableTypeFunction = (value) => {
    setEditElementData({ ...editElementData, table_type: value });
  };

  const editFieldData = () => {
    switch (editElementData.field_type) {
      case "recordset":
      case "recordset-list":
      case "grid":
      case "rich-grid":
        return (
          <RecordsetFieldDataForPositionScreen
            editElementData={editElementData}
            handleEditElementData={handleEditElementData}
            handleTableTypeFunction={handleTableTypeFunction}
            tableID={tableID}
          />
        );
      case "lookup-sm":
        return <LookupSmFieldData editElementData={editElementData} handleEditElementData={handleEditElementData} />;
      case "geolocation":
        return <EditGeolocation editElementData={editElementData} setEditElementData={setEditElementData} />;
      case "image":
      case "file":
      case "ocr":
      case "ai-doc-analyzer":
        return <EditFile editElementData={editElementData} setEditElementData={setEditElementData} />;
      default:
        return (
          <DefaultFieldData
            editElementData={editElementData}
            setEditElementData={setEditElementData}
            tableID={tableID}
            targetFolderPath={targetFolderPath}
          />
        );
    }
  };
  return (
    <div className="builder_form">
      <div className="flex_column gap_2">
        <Label>Field Name</Label>
        <div
          onClick={openModal}
          {...getToolTipAttributes(
            `${editElementData.id ? `${editElementData.prefix + "." + editElementData.display}` : "Select Field"}`
          )}
          className="builder_input cursor_pointer text_center"
        >
          {editElementData.id ? editElementData.display : "Select Field"}
        </div>
      </div>
      {editFieldData()}
      <BuilderModal isOpen={isModalOpen} onClose={closeModal} modalName="Select Field">
        <TableTreeModal
          callbackFunction={handleChangeField}
          tableId={tableID}
          selectedFile={
            editElementData && editElementData?.preview_field ? editElementData?.preview_field?.id : editElementData.id
          }
          folderId={targetFolderPath}
        />
      </BuilderModal>
    </div>
  );
};

const RecordsetFieldDataForPositionScreen = ({
  editElementData,
  handleEditElementData,
  // errorLabel,
  // handleTableTypeFunction,
  tableID
}) => {
  return (
    <div className="builder_form py_3">
      <Input
        type="checkbox"
        name="table_format"
        checked={editElementData.table_format || false}
        onChange={({ target }) => handleEditElementData(target.name, target.checked)}
        label="Table Format"
        containerClassName="w_50"
      />
      {!editElementData.table_format && (
        <CatalogEditContainer
          catalog={editElementData.catalog || {}}
          onChange={(data) => handleEditElementData("catalog", data)}
        />
      )}
      {editElementData.table_format && (
        <>
          <RecordsetTableType
            tableView={editElementData.table_view || {}}
            onChange={(data) => handleEditElementData("table_view", data)}
          />
          <p className="builder_label mt_2">Add Table Fields</p>
          <EditRecordviewOnScreenFilters
            filters={editElementData?.table_fields || []}
            saveFilters={(updatedFields) => handleEditElementData("table_fields", updatedFields)}
            tableId={tableID}
            tableType="form"
            folderId={[editElementData?.id]}
            EditFormFieldsComponent={EditTableFields}
          />
          {editElementData?.table_fields && editElementData?.table_fields.length === 0 && (
            <p className="d_flex align_center w_100 justify_center">No Fields Selected</p>
          )}
        </>
      )}
    </div>
  );
};

const RecordsetTableType = ({ tableView, onChange }) => {
  const handleChange = (key, value) => {
    onChange({ ...tableView, [key]: value });
  };
  return (
    <div className="builder_form">
      <Input
        type="checkbox"
        name="show_serial_number"
        checked={tableView.show_serial_number || false}
        onChange={({ target }) => handleChange(target.name, target.checked)}
        label="Show serial number"
        containerClassName="w_50"
      />
      <TableStyleTypes type={tableView.table_type || ""} onChange={(data) => handleChange("table_type", data)} />
    </div>
  );
};

const EditTableFields = ({ filter, onChange }) => {
  return (
    <div className="p_3 flex_column gap_4">
      <Input
        value={filter?.field_custom_label || ""}
        name="field_custom_label"
        label="Custom Label"
        placeholder={filter.field_custom_label || filter.display}
        onChange={(e) => onChange(e.target.name, e.target.value)}
      />
    </div>
  );
};

const EditGeolocation = ({ editElementData, setEditElementData }) => {
  const handleChange = (e) => {
    setEditElementData({ ...editElementData, show_full_map: e.target.checked });
  };
  return (
    <div>
      <Input
        type="checkbox"
        label="Show Full Map"
        name="show_full_map"
        checked={editElementData?.show_full_map}
        onChange={handleChange}
      />
    </div>
  );
};

export default EditField;
export { TableFieldAction, EditFieldForPositionedScreen };
